import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { acss } from '@adornis/chemistry/directives/acss.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('exd-year-button')
export class ExdYearButton extends ChemistryLitElement {
  @property({ attribute: true, type: Boolean }) disabled: boolean = false;

  override render() {
    return html`<button
      ?disabled=${this.disabled}
      ${acss({
        borderRadius: '6px',
        border: '1px solid rgba(0,0,0,0.0)',
        height: '31px',
        background: 'none',
        hover: { background: 'pink' },
        cursor: 'pointer',
        '&:not([disabled]):hover': {
          background: this.colors.neutral.shade(100),
          border: '1px solid ' + this.colors.neutral.shade(100),
        },
      })}
    >
      <x-flex horizontal crossaxis-center>
        <slot></slot>
      </x-flex>
    </button>`;
  }
}
